<template>
  <modal width="45" v-loading="loading" title="Trip Summary " :show-modal="showModal"
    @close-modal="$emit('close-modal')">
    <section v-if="isLoading">
      <div v-if="shipping.tripId" class="flex py-12 flex-wrap mt-3">
        <div class="w-full flex justify-center">
          <span class="loader">
            <img src="@/assets/images/ondemand/loader.svg" /></span>
        </div>
        <p class="w-full text-center pt-4 px-3">
          Fetching Shipment...<br />
          Might take a while, Please be patient.
        </p>
      </div>
      <div v-else class="flex py-12 flex-wrap mt-3 justify-center">
        No active trip
      </div>
    </section>
    <section v-else>

      <div class="mt-4 rounded p-3">
        <div class="mt-2 border-b-2 pb-1 border-dashed border-gray-300">
          <gmap-map :center="center[0]" ref="map" style="width: 100%; height: 400px" @place_changed="setPlace"
            :zoom="20">
            <directions-renderer travelMode="DRIVING" :origin="center[0]" :destination="center[1]"
              :directions="directions" :destinationLabel="destinationLabel" :orignLabel="originLabel" />
          </gmap-map>
          <div class="flex pb-2 items-center">
            <span class="block w-6/12 text-gray-500">Description</span>
            <span class="w-6/12 flex items-center justify-end">{{ totalpackageDiscription }}
              <button @click="isMinimize = !isMinimize" class="text-primary-yellow text-3xl ml-2">
                {{ isMinimize ? "&minus;" : "&plus;" }}
              </button>
            </span>
          </div>
          <div class="flex pb-2" v-if="isMinimize">
            <span class="block w-6/12 text-gray-500">Reciever</span>
            <span class="block w-6/12 text-right">{{
    shipping && shipping.destination ? shipping.destination.user.name : ''
  }}
              ({{
      shipping && shipping.destination ? shipping.destination.user.phoneNumber : ''
    }})</span>
          </div>
          <div class="flex pb-2" v-if="isMinimize">
            <span class="block w-6/12 text-gray-500">Sender</span>
            <span class="block w-6/12 text-right">{{
    shipping && shipping.origin ? shipping.origin.user.name : ''
  }}
              ({{
      shipping && shipping.origin ? shipping.origin.user.phoneNumber : ''
    }})</span>
          </div>
        </div>

        <div class="mt-2 border-b-2 pb-1 border-dashed border-gray-300">
          <div class="flex pb-2" v-if="liveTripData.status == 'accepted'">
            <span class="block w-6/12 text-gray-500">Pick-Up Time</span>
            <span class="block w-6/12 text-right">{{ displayPickupTime() }}</span>
          </div>
          <div class="flex pb-2" v-if="liveTripData.status == 'in-transit'">
            <span class="block w-6/12 text-gray-500">Estimated Delivery time</span>
            <span class="block w-6/12 text-right" v-if="liveTripData.info">
              {{ liveTripData.info ? liveTripData.info.duration.text : "---" }}
            </span>
            <span class="block w-6/12 text-right" v-else>
              {{ "fetching..." }}
            </span>
          </div>
          <div class="flex pb-2">
            <span class="block w-6/12 text-gray-500">Payment status </span>
            <span class="block w-6/12 text-right text-primary-green">{{
    'Paid'
  }}</span>
          </div>
        </div>

        <div class="mt-2 border-b-2 pb-1 border-dashed border-gray-300">
          <div class="flex pb-2">
            <span class="block w-6/12 text-gray-500">Dispatcher </span>
            <span class="block w-6/12 text-right">{{ liveTripData.driver ? liveTripData.driver.firstname : "" }}
              {{
    liveTripData.driver
      ? liveTripData.driver.lastname
      : "--"
  }}</span>
          </div>
          <div class="flex pb-2">
            <span class="block w-6/12 text-gray-500">Fleet Type</span>
            <span class="block w-6/12 text-right">{{
      liveTripData.driver.fleet.vehicleType || liveTripData.driver.fleet.type
        ? liveTripData.driver.fleet.type || liveTripData.driver.fleet.vehicleType
        : "N/A"
    }}</span>
          </div>
          <div class="flex pb-2">
            <span class="block w-6/12 text-gray-500">Vehicle Model</span>
            <span class="block w-6/12 text-right">{{
      liveTripData.driver.fleet.name || liveTripData.driver.fleet.vehicleModel
        ? liveTripData.driver.fleet.name || liveTripData.driver.fleet.vehicleModel
        : "N/A"
    }}</span>
          </div>
          <div class="flex pb-2">
            <span class="block w-6/12 text-gray-500">Vehicle Number</span>
            <span class="block w-6/12 text-right">{{
      liveTripData.driver.fleet.number || liveTripData.driver.fleet.vehicleNumber
        ? liveTripData.driver.fleet.number || liveTripData.driver.fleet.vehicleNumber
              : "N/A"
              }}</span>
          </div>
          <div class="flex pb-2">
            <span class="block w-6/12 text-gray-500">Status</span>
            <span class="block w-6/12 text-right capitalize" :class="statusType(liveTripData.status)">{{
              liveTripData.status ? liveTripData.status : "N/A"
              }}</span>
          </div>
        </div>

        <div class="mt-5 flex justify-between">
          <button @click="$emit('close-modal')">Cancel</button>
        </div>
      </div>
    </section>
  </modal>
</template>

<script>
import moment from "moment";
import SocketioService from "../../../../../services/socketio.service";
import DirectionsRenderer from "./DirectionRender.js";

export default {
  components: { DirectionsRenderer },
  props: {
    activeTripView: {
      type: Object
    },
    showModal: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  watch: {
    center: {
      handler() {
        // Do not auto focus, manage map bounds manually
        this.updateMapBounds();
      },
      deep: true
    },
    showModal(val) {
      this.socketEventName = this.activeTripView.id;
      if (this.socketEventName) {
        if (val) {
          this.registerSocket(this.socketEventName);
        }
        if (!val && this.socketEventName) {
          SocketioService.disconnect();
          clearInterval(this.interval);
        }
      }
      this.shouldShowMap && (this.isLoading = true);
      !val && (this.isLoading = false);
      this.setLiveTripData(this.activeTripView)
    },
    mapCordinate(val) {
      console.log("changed---cordinate", val);
    },
    shipping() {
      this.mapCordinate = this.center;
    },
  },
  mounted() {
    SocketioService.setupSocketConnection();
  },
  methods: {
    updateMapBounds() {
    },
    setPlace(val) {
      console.log(val);
    },
    statusType(status) {
      switch (status) {
        case 'delivered':
          return "text-primary-green"
        case "cancelled":
          return "text-red-600"
        case "accident-occured":
          return "text-red-600"
        default:
          return "text-primary-yellow"
      }
    },
    momentFormat(val) {
      return moment(val).format("MMMM Do YYYY")
    },
    setLiveTripData(val) {
      const extractedData = {
        driver: {
          fleet: val?.driver?.fleet ? { ...val?.driver?.fleet } : { ...val.fleet },
          lastname: val.driver.name || (`${val.driver.firstname} ${val.driver.lastname}`)
        },
        status: val.status
      }
      this.liveTripData = extractedData
      this.center = [
        {
          lat: val?.driver?.location?.latitude || 0,
          lng: val?.driver?.location?.longitude || 0,
        },
        {
          lat: val?.status == 'accepted' ? this.shipping?.origin?.lat : this.shipping?.destination?.lat,
          lng: val?.status == 'accepted' ? this.shipping?.origin?.long : this.shipping?.destination?.long,
        }
      ];
    },
    displayPickupTime() {
      // Input iOS date string            
      const iosDateString = this.liveTripData?.orign?.departure_time;

      // Parse the iOS date string using Moment.js
      const iosDate = moment(iosDateString);

      // Add 900 seconds
      const newIosDate = iosDate.add(this.liveTripData?.info?.duration?.value || 0, "seconds");

      // Format the new date as "YYYY-MM-DD, hh:mm"
      const formattedDate = newIosDate.format("YYYY-MM-DD, hh:mm");
      return formattedDate;
    },
    registerSocket(val) {
      SocketioService.setupSocketConnection();
      SocketioService.registerTripId(val);

      this.interval = setInterval(() => {
        SocketioService.tripInfo(val).then((data) => {
          this.isLoading = false;
          this.setLiveTripData(data)
          console.log(data)
        });
      }, 2000);
    },
    changeTimeFormat(val) {
      return moment(val).format("DD-MM-YYYY, hh:mm") ?? "";
    },
  },
  computed: {
    destinationLabel() {
      switch (this.liveTripData.status) {
        case 'accepted':
          return this.shipping.destination.user.name
        case 'in-transit':
          return this.shipping.origin.user.name

        default:
          return ''
      }
    },
    originLabel() {

     return (this.liveTripData.status == "accepted" || this.liveTripData.status == "in-transit") ? "Driver" : ''
    },
    totalpackageDiscription() {
      return this.shipping.description || ""
    },
    Dispatcher() {
      let handler = this.liveTripData?.driver?.fleet?.vehicleType?.toLowerCase();
      switch (handler) {
        case "bike":
          handler = "Rider of Bike";
          break;
        case "truck":
          handler = "Driver of Truck";
          break;
        case "car":
          handler = "Driver of Car";
          break;
        default:
          break;
      }
      return handler;
    },
    shipping() {
      return this.activeTripView;
    },
    shouldShowMap() {
      return (
        this.shipping?.shippingMethod === "door-to-door" ||
        (this.shipping?.shippingMethod === "terminal-to-door" &&
          !this.shipping?.shippingservice)
      );
    },
  },
  data() {
    return {
      loading: false,
      isMinimize: true,
      dispatcher: {},
      socketEventName: "",
      liveTripData: {},
      isLoading: false,
      interval: null,
      center: [
        { lat: 23.3, lng: 10.3 },
        { lat: 22.2, lng: 9.7 },
      ],
      directions: [
        {
          origin: { lat: 37.7749, lng: -122.4194 },
          destination: { lat: 37.7749, lng: -122.5194 },
          // zoomLevel: 15,
          polyline: {
            path: [],
            geodesic: true,
            strokeColor: "#FF0000",
            strokeOpacity: 1.0,
            strokeWeight: 2,
          },
        },
        // Add more direction objects if needed
      ],
    };
  },
  beforeDestroy() {
    SocketioService.disconnect();
    clearInterval(this.interval);
  },
};
</script>

<style lang="scss" scoped>
.loader {
  display: inline-block;
  width: auto;
  height: auto;
  animation: 2s infinite linear rolls;
}

@keyframes rolls {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}
</style>